import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
const timeline = [{
  year: '2004',
  title: 'Founded',
  body: 'Periscan founded by Sean Heiney with a thesis ahead of its time: security assessment should be automated, continuous, and outside-in.'
}, {
  year: '2005',
  title: "Hacker's-eye view",
  body: 'Periscan described its service as managed automated network security — providing a constant "hacker\'s eye view" of customer networks.'
}, {
  year: '~2010',
  title: 'Acquired',
  body: 'The original Periscan was acquired by Catbird Networks. The brand eventually went quiet.'
}, {
  year: '2026',
  title: 'Reborn',
  body: 'Periscan returns, rebuilt by its original founder for cloud, identity, SaaS, code, and AI applications.',
  active: true
}];
export function History() {
  return <section className="relative w-full py-32 border-t border-white/5 overflow-hidden" data-id="element-537">
      {/* Massive faded background type */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-538">
        <div className="font-mono text-[20vw] font-bold text-white/[0.015] tracking-tighter leading-none select-none" data-id="element-539">
          2004→2026
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8" data-id="element-540">
        <SectionLabel number="04" label="History" className="mb-8" data-id="element-541" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-542">
          <div className="lg:col-span-8" data-id="element-543">
            <SectionHeading size="xl" data-id="element-544">
              Periscan was early.
              <br data-id="element-545" />
              <span className="text-white/40" data-id="element-546">The market caught up.</span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-4 lg:pt-4" data-id="element-547">
            <p className="text-lg text-white/60 leading-relaxed" data-id="element-548">
              The original Periscan helped companies continuously understand
              exposure. The new Periscan helps companies find the path, fix the
              risk, and prove it is gone.
            </p>
          </div>
        </div>

        {/* Timeline */}
        <div className="relative" data-id="element-549">
          {/* Vertical line */}
          <div className="absolute left-[7.5rem] top-0 bottom-0 w-px bg-white/5 hidden md:block" data-id="element-550" />

          <div className="space-y-12" data-id="element-551">
            {timeline.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="relative grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 items-start" data-id="element-552">
                <div className="md:col-span-2 flex items-center gap-4" data-id="element-553">
                  <span className={`font-mono text-2xl font-semibold ${item.active ? 'text-[#1a8fd4]' : 'text-white/60'}`} data-id="element-554">
                    {item.year}
                  </span>
                </div>
                <div className="md:col-span-1 hidden md:flex items-center justify-center relative" data-id="element-555">
                  <div className={`relative z-10 w-3 h-3 rounded-full ${item.active ? 'bg-[#1a8fd4] shadow-[0_0_12px_#1a8fd4]' : 'bg-white/20'}`} data-id="element-556" />
                </div>
                <div className="md:col-span-9" data-id="element-557">
                  <h3 className="text-xl font-semibold text-white mb-2" data-id="element-558">
                    {item.title}
                  </h3>
                  <p className="text-base text-white/60 leading-relaxed" data-id="element-559">
                    {item.body}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}